import React, {  useState } from 'react';
import emailjs from '@emailjs/browser';

import AnimationData from '../../lottiefiles/contactus.json'
import Lottie from 'lottie-react'
import { Button, Toolbar, Typography } from '@mui/material'
import './Contact.css'
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import { NavLink } from 'react-router-dom';
import CallIcon from '@mui/icons-material/Call';
import EmailIcon from '@mui/icons-material/Email';
import NearMeIcon from '@mui/icons-material/NearMe';
import { ContactHeading } from '../../components/Comp/AllComponents'
import SocialButtons from '../../components/SocialButtons/SocialButtons'



// const purples = deepPurple[700];

const Contact = () => {

  // const form = useRef();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();

    const serviceId = 'service_4m6tae9';
    const templateId = 'template_s2xzjrq';
    const publickKey = 'KT2vw-_ja-eG3NaRA';

    const templateParams = {
      from_name: name,
      from_email: email,
      to_name: 'Abhishek Technical',
      message: message,
    };

    emailjs.send(serviceId, templateId,templateParams, publickKey)
      .then((response) => {
        console.log('Message sent successfully', response);;
        setName('');
        setEmail('');
        setMessage('');
      })
      .catch((error) => {
        console.log('FAILED...', error.text);
      });
  }


  function RedBar() {
    return (



      <Box
        sx={{
          height: 20,
          width: 360,
          borderRadius: 4,
          backgroundColor: (theme) =>
            theme.palette.mode === 'light'
              ? 'rgba(255, 0, 0, 0.1)'
              : 'rgb(255 132 132 / 25%)',
        }}
      />
    );
  }



  return (
    <>
      <Toolbar />
      {/* <Toolbar /> */}

      <Typography
        className='mainContactDiv container'
        variant='div'
        component={'div'}
      >
        <ContactHeading />

        <Typography
          className='contact'
          variant='div'
          component={'div'}
          sx={{
            display: 'flex'
          }}
        >
          {/* left side */}
          <Typography
            className='leftContact'
            variant='div'
            component={'div'}

          >
            <Typography
              variant='h4'
              component={'div'}
              sx={{ color: '#231542' }}
            >
              Hire/Inquiry
              <Typography
                variant='p'
                component={'p'}
              >
                Call Me
              </Typography>
            </Typography>

            <Typography
              className='contactor'
              variant='div'
              component={'div'}
            >
              <Typography
                className='p'
                variant='p'
                component={'p'}
              >
                <CallIcon /> +918429554884
              </Typography>
              <Typography
                className='p'
                variant='p'
                component={'p'}
              >
                <EmailIcon /> <NavLink to='https://mail.google.com' target='_blank' >er.abhishek2030@gmail.com</NavLink>
              </Typography>
              <Typography
                className='p'
                variant='p'
                component={'p'}
              >
                <NearMeIcon /> Bhopal,M.P.
              </Typography>
            </Typography>

            {/* Social Media icons */}
            <div className="social-icon">
              < SocialButtons />
            </div>
            {/* <SocialMedia /> */}



          </Typography>

          {/* right side */}
          <Typography
            className='rightContact'
            variant='div'
            component={'div'}
            sx={{
              flex: '1',
              display: 'flex',
            }}
          >
            <Typography
              className='lottie'
              variant='div'
              component={'div'}
              sx={{
                width: '60%',
                height: '20%',
                mb: 4,
                ml: 4
              }}
            >
              <Lottie
                animationData={AnimationData}
                loop={true}
              />
            </Typography>

            {/* contact form */}
            <Typography
              className='contactForm'
              variant='div'
              component={'div'}
            >
              <form  onSubmit={handleSubmit} >
                <RedBar className="redbar" />
                <TextField
                  label={'Enter Name'}
                  type='text'
                  id="margin-none"
                  color='secondary'
                  // name="user_name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  focused
                  sx={{

                  }}
                />
                <RedBar className="redbar" />
                <TextField
                  label={'Enter Email-Id'}
                  type='email'
                  id="margin-dense"
                  color='secondary'
                  // name="user_email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <RedBar className="redbar" />
                <TextField
                  className='message'
                  fullWidth
                  label="Message"
                  // name='message'
                  color='secondary'
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  multiline
                  rows={4}
                  variant="outlined"
                  sx={{
                    color: '#360161'
                  }}
                />
                <RedBar className="redbar" />
                <Button
                  type='submit'
                  size='small'
                  variant='contained'
                  className='home_btn btn' 
                  sx={{
                    backgroundColor: '#138781',
                    fontSize: 18, mt: 4
                  }}
                >
                  Contact Me
                </Button>

              </form>

            </Typography>

          </Typography>

        </Typography>
      </Typography>

    </>
  )
}

export default Contact
